window.addEventListener('load', function () {
    if (document.querySelectorAll('.videoElement').length) {
        const elements = document.querySelectorAll('.videoElement');

        elements.forEach(function (element) {
            var video = element.querySelector('video');
            var src = element.querySelector('source');
            var button = element.querySelector('button');

            button.addEventListener('click', function (event) {
                if (video.paused) {
                    video.play();
                    video.setAttribute('controls', 'controls');
                    video.classList.add('active');
                }
            });

            var small = window.matchMedia('(max-width: 720px)');
            var medium = window.matchMedia('(min-width: 721px) and (max-width: 1280px)');

            if (small.matches && src.dataset.hasOwnProperty('small')) {
                src.setAttribute('src', src.getAttribute('data-small'));
                video.load();
            }

            if (medium.matches && src.dataset.hasOwnProperty('medium')) {
                src.setAttribute('src', src.getAttribute('data-medium'));
                video.load();
            }

            video.onended = function () {
                video.load(); // show poster again
                video.classList.remove('active'); // show button again
                video.removeAttribute('controls'); // remove controls
            };
        });
    }
});
